import React, { useEffect, useState } from "react";
import { useMilesPoints } from "../../../../hooks/useMilesPoints";

function MilesRankDetailModalStatsSection({ board }) {
  const { getUserMilesPoints } = useMilesPoints();
  const [data, setData] = useState({
    week: 0,
    month: 0,
    cycle: 0,
    alltime: 0,
  });
  const [loading, setLoading] = useState(false);
  const numberToStaring = (num) => {
    return num?.toLocaleString();
  };
  const stats = [
    {
      label: "Points This Week",
      amount: numberToStaring(data?.week),
    },
    {
      label: "Points This Month",
      amount: numberToStaring(data?.month),
    },
    {
      label: "Total Points Earned",
      amount: numberToStaring(data?.alltime),
    },
    {
      label: "Highest Points in a Cycle",
      amount: numberToStaring(data?.cycle),
    },
  ];

  const loadData = async () => {
    await getUserMilesPoints({
      userId: board?.userId,
      setLoading,
      callback: (content) => {
        setData({
          week: content?.pointsThisWeek || 0,
          month: content?.pointsThisMonth || 0,
          cycle: content?.highestCycle || 0,
          alltime: content?.totalAmount || 0,
        });
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [board]);

  if (loading)
    return (
      <div className="flex items-center justify-center w-full py-6">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="flex gap-4 flex-wrap w-full justify-between border-b pb-6 border-black/10 ">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex w-[48%] h-28 rounded-xl flex-col border border-black/10 p-4 justify-center bg-[#F9F9F9]"
        >
          <span className="text-sm">{stat.label}</span>
          <span className="text-lg">{stat.amount}</span>
        </div>
      ))}
    </div>
  );
}

export default MilesRankDetailModalStatsSection;
